export default {
  outline: 'none'
}
